import React from 'react';
import PageNotFound from '../../components/page-not-found/PageNotFound';

function PageNotFoundPage({setShow}) {
  return (
    <><PageNotFound setShow={setShow} /></>
  )
}

export default PageNotFoundPage;